import { useTranslations } from 'next-intl';
import { getIsAntiWaste } from '@monofront/business/utils';
import { IProduct } from '@monofront/types';
import { useAuthentication } from '@context/businessContainer';
import { useNotifyMe } from '@monofront/business/hooks';
import { toast } from 'react-toastify';
import ModalNotifyMe from '@components/ModalNotifyMe';
import { useState } from 'react';
import Notification from '@monofront/design-system/visuals/Icons/Notification';
import { IconSizes } from '@monofront/design-system/visuals/Icons/type';
import Loader from '@monofront/design-system/components/Button/Loader';

interface IProductNotifyMeProps {
  product: IProduct;
}

const ProductNotifyMe: React.FC<IProductNotifyMeProps> = ({ product }) => {
  const { isAuthenticated, customer } = useAuthentication();
  const { loading, notifyMe } = useNotifyMe();
  const isAntiWaste = getIsAntiWaste(product.tags);
  const tCatalog = useTranslations('Catalog');
  const [isNotifyMeModalOpen, setIsNotifyMeModalOpen] = useState(false);

  const handleNotifyMe = async (): Promise<void> => {
    await notifyMe({
      email: customer!.email,
      sku: product.sku,
      successCallback: (messageKey) => {
        toast(tCatalog(messageKey));
      },
      errorCallback: (errorMessageKey) => {
        toast(tCatalog(errorMessageKey), {
          progressClassName: 'toast-error',
        });
      },
    });
  };

  if (product.inventory_available || isAntiWaste) {
    return null;
  }

  if (!isAuthenticated || !customer?.email) {
    return (
      <>
        <ModalNotifyMe
          title={product.title}
          isOpen={isNotifyMeModalOpen}
          externalToggle={() => setIsNotifyMeModalOpen(!isNotifyMeModalOpen)}
          sku={product.sku}
        />
        <button
          type="button"
          className="tw-lf-button tw-lf-button-primary tw-lf-button-lg tw-relative tw-px-6"
          onClick={() => setIsNotifyMeModalOpen(true)}
          data-testId="NotifyMeButton-Button-open"
        >
          {loading && <Loader />}
          <Notification
            size={IconSizes.lg}
            UNSAFE_className={loading ? 'tw-invisible' : ''}
          />
          <span className={loading ? 'tw-invisible' : ''}>
            {tCatalog('notifyMeV2')}
          </span>
        </button>
      </>
    );
  }

  return (
    <button
      type="button"
      className="tw-lf-button tw-lf-button-primary tw-lf-button-lg tw-relative tw-px-6"
      onClick={() => handleNotifyMe()}
      data-testId="NotifyMeButton-Button-submit"
    >
      {loading && <Loader />}
      <Notification
        size={IconSizes.lg}
        UNSAFE_className={loading ? 'tw-invisible' : ''}
      />
      <span className={loading ? 'tw-invisible' : ''}>
        {tCatalog('notifyMeV2')}
      </span>
    </button>
  );
};

export default ProductNotifyMe;
